import React from 'react'
import { FaWhatsapp } from 'react-icons/fa';
import './whatsButton.css'

const WhatsButton = ({ message }) => {
    const whatsappLink = 'https://api.whatsapp.com/send?phone=5511943421608&text=Oi,%20vi%20o%20seu%20site%20pelo%20Google%20e%20tenho%20interesse%20em%20come%C3%A7ar%20o%20processo%20terap%C3%AAutico.%20Como%20podemos%20dar%20o%20primeiro%20passo%3F';

    return (
        <div className="psico__message-button">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                <button type="button">
                    <span className="psico__message-button__icon">
                        <FaWhatsapp />
                    </span>
                    {message}
                </button>
            </a>
        </div>
    )
}

export default WhatsButton
